<template>
  <div id="app-index">
    <div class="index-box">
      <div class="logo">
        <img :src="logoUrl" alt />
      </div>
      <div class="amount_box">
        <div class="money">
          总捐款额
          <numScroll :value="amount"></numScroll>元
        </div>
        <div class="number">
          总人次
          <numScroll :value="number"></numScroll>次
        </div>
      </div>
      <div class="main">
        <div class="code_box">
          <div class="qrcode_box">
            <p>扫码捐赠</p>
            <div id="qrcode" ref="qrcode"></div>
            <p>技术支持：长沙普益云软件科技有限公司</p>
          </div>
        </div>
        <div class="scroll_box">
          <div class="title">最新捐赠记录</div>
          <vue-seamless-scroll :data="peopleData" :class-option="classOption" class="seamless-warp">
            <ul>
              <li v-for="(item,index) in peopleData" :key="index">
                <div class="p-box">
                  <img v-if="item.headimg_url" :src="item.headimg_url" alt />
                  <img v-else src="../../assets/images/headPortrait.png" alt />
                  <span :title="item.pub_name||'爱心人士'">{{item.pub_name||'爱心人士'}}</span>
                </div>
                <i>
                  <span>￥{{item.money}}</span>
                </i>
                <b :title="item.desc">{{item.desc}}</b>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import numScroll from "./numScroll";
import QRCode from "qrcodejs2";
import { mapActions } from "vuex";
export default {
  components: {
    numScroll
  },
  data() {
    return {
      amount: 0,
      peopleData: [],
      animate: true,
      number: 0,
      logoUrl: "",
    };
  },
  created() {
    let that = this;
    //查询所有捐赠信息
    this.$db.get(this.$url.donation.list).then(resp => {
      if (resp && resp.data) {
        that.peopleData = resp.data;
      }
    }).catch(err => {
            console.log(err);
          });
    //查询捐赠总人数和总金额
    that.$db.get(that.$url.donation.index).then(resp => {
      if (resp && resp.data) {
        that.amount = Number(resp.data.donation_sum);
        that.number = Number(resp.data.donation_count);
      }
    }).catch(err => {
            console.log(err);
          });
    let ws = new WebSocket(this.$wsUrl);
    ws.onopen = function() {
      ws.send('{"type":"big_screen"}');
    };
    ws.onmessage = function({ data }) {
      data = JSON.parse(data);
      // //根据返回的订单号查询对应的捐赠数据并累加
      let info = {
        pub_name: data.pub_name,
        headimg_url: data.headimg_url,
        money: data.money,
        desc: data.desc
      };
      that.peopleData.push(info);
      that.amount += parseInt(info.money);
      that.number++;
    };
  },
  mounted() {
    this.getWebconfigInfo().then(res => {
      this.webconfig = res;
      this.logoUrl = res.logo_text.url; //设置logo
      this.$store.state.webInfo = res;
    }).catch(err => {
            console.log(err);
          });
    this.qrcode();
  },
  computed: {
    classOption() {
      return {
        step: 0.5,
        direction:0
      };
    }
  },
  methods: {
    ...mapActions(["getWebconfigInfo"]),
    qrcode() {
      setTimeout(() => {
          // document.getElementById("qrcode").innerHTML = "";
        new QRCode(this.$refs.qrcode, {
          text:
            this.$store.state.webInfo.donation_url +
            this.$store.state.webInfo.donation_project_id,
          width: 250,
          height: 250,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.L
        });
      }, 100);
    }
  },
};
</script>

<style lang="less" scoped>
#app-index {
  width: 1920px;
  min-width: 1920px;
  height: 1080px;
  background: url("../../assets/images/donate_bg.png") no-repeat;
}
.index-box {
  width: 100%;
  position: relative;
  .logo {
    position: absolute;
    top: 65px;
    left: 490px;
    width: 265px;
    height: 48px;
    > img {
      width: 100%;
    }
  }
  .amount_box {
    margin: 224px 0 0 369px;
    display: inline-block;
    /deep/ .number-grow {
      color: #1afbfe;
    }
    .money,
    .number {
      float: left;
      color: #d2c14f;
      margin-right: 262px;
      > div {
        width: 300px;
        height: 92px;
        text-align: center;
        background-color: #1f1f22;
        box-shadow: 0px 4px 0px 0px rgb(0, 0, 0);
        border-radius: 4px;
        line-height: 92px;
        margin: 0 30px;
      }
    }
  }
  .main {
    margin: 0 158px;
    padding-top: 74px;
    display: flex;
    .code_box {
      width: 522px;
      height: 500px;
      background-color: #242529;
      .qrcode_box {
        color: #fff;
        text-align: center;
        p:nth-of-type(1) {
          margin: 41px 0 48px 0;
          display: inline-block;
          font-size: 20px;
        }
        p:nth-of-type(2) {
          margin-top: 45px;
          display: inline-block;
          font-size: 16px;
        }
        #qrcode {
          width: 250px;
          height: 250px;
          padding: 10px;
          background-color: #fff;
          margin: 0 auto;
        }
      }
    }
  }
  .scroll_box {
    width: 1050px;
    height: 500px;
    overflow: hidden;
    transition: all 0.5s;
    margin-left: 31px;
    background-color: #242529;
    .title {
      height: 88px;
      line-height: 88px;
      font-size: 20px;
      color: #fff;
      text-align: center;
      border-bottom: solid 1px #313236;
      margin: 0 12px;
    }
    .seamless-warp {
      overflow: hidden;
      margin: 26px 0 32px 49px;
      height: 360px;
      ul {
        overflow: hidden;
        margin: 0;
        // padding: 32px 48px;
        > li {
          list-style: none;
          width: 95%;
          height: 72px;
          display: flex;
          background-size: 100% 100%;
          padding-right: 5%;
          overflow: hidden;
          .p-box {
            display: flex;
            width: 26%;
            > img {
              width: 40px;
              height: 40px;
              margin-top: 16px;
              border-radius: 50%;
            }
            span {
              font-size: 18px;
              font-weight: 600;
              color: #aeaeae;
              line-height: 72px;
              margin-left: 11px;
              overflow: hidden;
              white-space: nowrap; /*不换行*/
              text-overflow: ellipsis; /*超出部分省略号显示*/
            }
          }

          > i {
            width: 30%;
            font-size: 18px;
            font-weight: 600;
            color: #fff;
            // line-height: 6.7vh;
            font-style: normal;
            position: relative;
            > span {
              display: block;
              text-align: center;
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
            }
          }
          > b {
            width: 40%;
            font-size: 14px;
            font-weight: normal;
            color: #666;
            float: right;
            line-height: 72px;
            overflow: hidden;
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分省略号显示*/
          }
        }
      }
    }
  }
}
// .scroll_box /deep/ .el-button {
//   font-size: 1vw;
//   color: #fff;
//   background-color: none;
//   border: none;
//   padding: 3% 6%;
//   border: none;
// }
.anim {
  transition: all 1s;
}
</style>



// WEBPACK FOOTER //
// src/components/donation/list.vue